import React, { useEffect, useState } from "react";
import imageP from "../../assets/images/maqueta/imgfaqs1.jpg";
import fondoGrande from "../../assets/images/maqueta/fondo_faq_grande.jpg";
import fondoChico from "../../assets/images/maqueta/fondo_faq_chica.jpg";
import "./faqs.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { Tabs, Tab } from "react-bootstrap";
import CardDownloads from "./CardDownloads";

// import useFaqs from "../../hooks/useFaqs";

import useProduct from "../../hooks/useProduct";
import FaqsDinamic from "./FaqsDinamic";
import { getGeneralFaqs } from "../../services/getGeneralFaqs";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  "&:not(:last-child)": {
    borderBottom: 0
  },
  "&:before": {
    display: "none"
  }
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)"
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1)
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "#00aff1"
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2)
  // borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const FaqsTabs = (props) => {
  const { generalFaqs, expanded, handleChange, products } = props;
  const [key, setKey] = useState("faqs");
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const tabletBreakpoint = 768;

  const handleWindowResize = () => {
    setViewportWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return (
    <div className="faqs-tabs">
      <Tabs
        id="faqs-tabs__tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="faqs-tabs__tabs"
      >
        <Tab
          eventKey="faqs"
          title={
            viewportWidth < tabletBreakpoint ? (
              key === "faqs" ? (
                "Preguntas Frecuentes"
              ) : (
                <QuizOutlinedIcon />
              )
            ) : (
              "Preguntas Frecuentes"
            )
          }
        >
          <div className="faqs__block-accordion">
            <article className="general-faqs--container">
              {generalFaqs?.length >= 0
                ? generalFaqs.map(
                    (gen, index) =>
                      gen.category &&
                      !gen.deleted && (
                        <div key={index} className="col-12 col-sm-6 mb-4 pe-5 pe-sm-5 pe-lg-0">
                          <h2 className="faqs_empresa--title" id="faqs_empresa">
                            {gen.category}
                          </h2>
                          <div className="categories mt-3">
                            {gen.faq?.map((faq, index) => (
                              <div key={index}>
                                <Accordion
                                  expanded={expanded === `panel${index}-${gen._id}`}
                                  onChange={handleChange(`panel${index}-${gen._id}`)}
                                >
                                  <AccordionSummary
                                    aria-controls={`panel${index}-${gen._id}d-content`}
                                    id={`panel${index}-${gen._id}d-header`}
                                  >
                                    <Typography>{faq.question}</Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <Typography
                                      className="faqs-tiny-editor"
                                      dangerouslySetInnerHTML={{
                                        __html: faq.answer
                                      }}
                                    >
                                      {/* {faq.answer} */}
                                    </Typography>
                                  </AccordionDetails>
                                </Accordion>
                                <hr />
                              </div>
                            ))}
                          </div>
                        </div>
                      )
                  )
                : ""}
            </article>
          </div>
        </Tab>
        <Tab
          eventKey="downloads"
          title={
            viewportWidth < tabletBreakpoint ? (
              key === "downloads" ? (
                "Descargas"
              ) : (
                <FileDownloadOutlinedIcon />
              )
            ) : (
              "Descargas"
            )
          }
        >
          <CardDownloads products={products} />
        </Tab>
      </Tabs>
    </div>
  );
};

const Faqs = () => {
  const { products, getAllProducts } = useProduct();
  const [expanded, setExpanded] = React.useState("panel1");
  const [generalFaqs, setGeneralFaqs] = useState([]);

  useEffect(() => {
    getGeneralFaqs().then((res) => {
      const getAllFaqs = res.data.allFaqs.filter((faq) => !faq.deleted);

      setGeneralFaqs(getAllFaqs);
    });
    getAllProducts({ onlyTitleAndIcon:false, visible: true });
  }, []);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      {/* Intro FAQS */}
      <div id="faqs" className="bg-fullpage ">
        <img src={imageP} alt="" />

        <picture>
          <source
            media="(orientation: portrait) and (max-width: 767px)"
            srcSet={fondoChico}
            alt="header_calculadora"
            className="imagen-fondo img-responsive-inter"
            title="calculadora"
          />
          <source
            media="(orientation: landscape) and (max-width: 767px)"
            srcSet={fondoGrande}
            alt="header_calculadora"
            className="imagen-fondo img-responsive-inter"
            title="calculadora"
          />
          <img
            className="imagen-fondo img-responsive-inter"
            src={fondoGrande}
            alt="header_calculadora"
            title="calculadora"
          />
        </picture>

        <section className="container halfintro">
          <div className="card-info col-12 col-xl-9 col-lg-9 col-md-9 col-sm-12">
            <div className="cuadrado-azul"></div>
            <div className="row">
              <div className="col-lg-3 col-md-12">
                <h1 className="">FAQS </h1>
              </div>
              <div className="col-lg-9 col-md-12">
                <h2>Soporte, preguntas frecuentes y respuestas</h2>
                <p className="faqs__destacado">
                  Queremos resolverte tus consultas de forma ágil. Encontrá consejos de nuestros
                  productos, información institucional o resolvé tus dudas si sos proveedor{" "}
                </p>

                <p>Podés consultar sobre las siguientes categorías:</p>

                <ul className="settings__list-tags-buttons faqs-grid-buttons">
                  {generalFaqs?.length >= 0
                    ? generalFaqs.map(
                        (gen, index) =>
                          gen.category &&
                          !gen.deleted && (
                            <li className="settings_button-border button-b-white" key={index}>
                              <a href="#faqs_empresa">{gen?.category}</a>
                            </li>
                          )
                      )
                    : ""}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="container settings__block-inferior">
        <nav aria-label="#faqs" className="">
          <h2>Productos</h2>
          <ul className="d-lg-flex flex-lg-row flex-lg-wrap flex-lg-column my-2 display-faqs-bottoms">
            {products?.map(
              (producto, index) =>
                producto.type === "productoLinea" &&
                producto.deleted !== true &&
                producto.faqs?.length !== 0 && (
                  <li key={index} className={`${producto.faqsEnabled ? "" : "d-none"}`}>
                    <input type="checkbox" id="active" />
                    <label htmlFor="active">
                      <FaqsDinamic producto={producto} />
                    </label>
                  </li>
                )
            )}
          </ul>
        </nav>

        {/* TABS */}
        <FaqsTabs
          generalFaqs={generalFaqs}
          expanded={expanded}
          handleChange={handleChange}
          products={products}
        />
      </section>
    </>
  );
};

export default Faqs;
